import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import Cta from "@qlik/qlik/src/components/Cta";
import { getCardDescriptionText, getCardMedia, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import RichText from "@qlik/qlik/src/components/RichText";
import * as styles from "./styles.module.css";

/**
 * Renders a single card without borders.
 * @param {Object} props - The component props.
 * @param {string} props.icon - The icon for the card.
 * @param {string} props.title - The title of the card.
 * @param {string} props.paragraph - The paragraph content of the card.
 * @param {Object} props.listItems - The list items for the card.
 * @param {Object[]} props.links - The links for the card.
 * @param {string} props.subtitle - The subtitle of the card.
 * @returns {JSX.Element} - The rendered component.
 */
const SingleCardNoBorder = ({ data }) => {
    const { title, body, cta, subtitle } = data ?? {};

    const paragraph = getCardDescriptionText(data);

    const ctaLinks = cta?.filter((link) => link !== "");
    /* eslint-disable-next-line no-unneeded-ternary */
    const cardMedia = getCardMedia(data);

    const jsonData = body ? <RichText data={data} className={`${ctaLinks ? "hasLinks" : "noLinks"}`} /> : null;
    const headlineMBottom = paragraph ? "mb-2.5" : "mb-7.5";
    const paragraphTop = subtitle ? "" : "mt-3.75";
    const paragraphMBottom = jsonData ? "mb-0" : "mb-3.75 md:mb-7.5";

    return (
        <div
            className={`flex flex-col h-full  mb-0 md:mb-2.5 p-3.75 pb-0  md:pb-3.75  ${styles.mobileTitle} ${styles.paragraphSpacing}`}
        >
            <div className="flex-1">
                {cardMedia && <Media media={cardMedia} className="w-[90px] h-12 object-contain mb-7.5 object-left" />}
                {title && (
                    <h3
                        className={`card-title title-4 ${headlineMBottom}`}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                    />
                )}
                {subtitle && <p className="text-blue mb-3.75">{subtitle}</p>}
                {paragraph && <p className={`leading-snug ${paragraphMBottom} ${paragraphTop}`}>{paragraph}</p>}

                {jsonData}
            </div>
            {ctaLinks && ctaLinks.length > 0 && (
                <div className=" list-none">
                    {cta.map((link, index) => (
                        <Cta
                            key={link.id}
                            data={link}
                            className={`block ${index === ctaLinks.length - 1 ? "mb-0" : "mb-3.75"}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SingleCardNoBorder;
